import { render, staticRenderFns } from "./EmailAccountBlock.vue?vue&type=template&id=c70ad27a"
import script from "./EmailAccountBlock.vue?vue&type=script&lang=js"
export * from "./EmailAccountBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports